import React from 'react';

// styles
import {  Container , Row , Col  } from 'react-bootstrap';
import { Paper } from '@material-ui/core';

export default function CompanyProfileLink(props) {
    return(
        <Container fluid className="profileStrength mt-3 mb-3 p-0">
        <Paper>
            <Row className="m-0 p-3">
                <Col xs={12} className="p-0 mb-2">
                    <h6 className="bold">Company Visibility</h6>
                    </Col>
                <Col xs={12} className="p-0 mb-2 bg-lightRed p-2">
                    <p className="mb-0 text-grey">
                        Here is your public profile link:
                        <br/>
                        <span className="text-orange">Spreago.net/me/marwa-rabie-4a957ca252</span>
                    </p>
                </Col>
            </Row>
        </Paper>
    </Container>
    )
}